<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div>
    <div style="height: 100%; background-color: white; color: #3d3d3d; padding-top: 10px; padding-left: 70px; padding-right: 70px; padding-bottom: 10px;">
        <div class="row">
            <div class="col-sm-2 col-12">
                <div>
                    <kkis-app-webshop-top-level-nav1 [reihenfolgeTree]="reihenfolgeTree" [minPreis]="minPreis" [maxPreis]="maxPreis" [isExpanded]="true"></kkis-app-webshop-top-level-nav1>
                </div>
                <div class="mt-4">
                    <kkis-app-webshop-filter-container1 
                        [category]="category" 
                        [minPreis]="minPreis" 
                        [maxPreis]="maxPreis" 
                        [groessen]="groessen"
                        [farben]="farben"
                        [nurAufLager]="nurAufLager"
                        [filterGroessen]="filterGroessen"
                        [filterFarben]="filterFarben"
                        [filterMerkmale]="filterMerkmale"
                        [merkmalGruppen]="merkmalGruppen"
                        [removeFilter]="removeFilter">
                    </kkis-app-webshop-filter-container1>
                </div>
            </div>
            <div class="col-sm-10 col-12">
                <div>
                    <kkis-app-webshop-filter-chips
                        [filterMerkmale]="filterMerkmale"
                        [merkmalGruppen]="merkmalGruppen"
                        (filterRemoved)="getRemoveFilter($event)">
                    </kkis-app-webshop-filter-chips>
                </div>
                <div>
                    <kkis-app-webshop-filter-container-category1 [reihenfolgeTree]="reihenfolgeTree" [category]="category"></kkis-app-webshop-filter-container-category1>
                </div>
                <div>
                    <kkis-app-artikel-list1 
                        [search]="search"
                        [category]="category" 
                        [minPreisFilter]="minPreisFilter" 
                        [maxPreisFilter]="maxPreisFilter" 
                        [filterGroessen]="filterGroessen"
                        [filterFarben]="filterFarben"
                        [filterMerkmale]="filterMerkmale"
                        [nurAufLager]="nurAufLager"
                        (minPreis)="getMinPreis($event)" 
                        (maxPreis)="getMaxPreis($event)" 
                        (groessen)="getGroessen($event)" 
                        (farben)="getFarben($event)"
                        (merkmalGruppen)="getMerkmalGruppen($event)"
                        (numberWarenkorbItems)="getNumberWarenkorbItems($event)">
                    </kkis-app-artikel-list1>
                </div>
            </div>
        </div>
    </div>
</div>